import { Directive, ElementRef, Input, TemplateRef, ViewContainerRef, inject } from '@angular/core';
import { PermissionsDTO } from '@api';
import { TokenService } from './token.service';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[hasPermission]',
  standalone: false,
})
export class HasPermissionDirective {
  private element = inject(ElementRef);
  private templateRef = inject<TemplateRef<unknown>>(TemplateRef);
  private viewContainer = inject(ViewContainerRef);
  private tokenService = inject(TokenService);

  /*
  If no permission is passed or the user has ANY of the passed permissions, then this qualifies as permitted
   */
  @Input()
  set hasPermission(permissionsDTO: PermissionsDTO | PermissionsDTO[]) {
    if (!permissionsDTO || !permissionsDTO.length || this.tokenService.hasPermission(permissionsDTO)) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
